// @flow
import React from 'react'
import Helmet from 'react-helmet'
import appleIcon192 from 'assets/favicons/touch-icon-192x192.png'
import appleIcon180 from 'assets/favicons/apple-touch-icon-180x180-precomposed.png'
import appleIcon152 from 'assets/favicons/apple-touch-icon-152x152-precomposed.png'
import appleIcon144 from 'assets/favicons/apple-touch-icon-144x144-precomposed.png'
import appleIcon120 from 'assets/favicons/apple-touch-icon-120x120-precomposed.png'
import appleIcon114 from 'assets/favicons/apple-touch-icon-114x114-precomposed.png'
import appleIcon76 from 'assets/favicons/apple-touch-icon-76x76-precomposed.png'
import appleIcon72 from 'assets/favicons/apple-touch-icon-72x72-precomposed.png'
import appleIcon from 'assets/favicons/apple-touch-icon-precomposed.png'
import favicon32 from 'assets/favicons/favicon-32x32.png'
import favicon96 from 'assets/favicons/favicon-96x96.png'
import favicon16 from 'assets/favicons/favicon-16x16.png'
import favicon from 'assets/favicons/favicon.ico'
import msIcon from 'assets/favicons/ms-icon-144x144.png'
import maskIcon from 'assets/favicons/pin_icon.svg'
import structuredData from 'assets/structuredData.json'

type Props = {
  pageTitle: string,
  description: string,
}

const DefaultHead = ({ pageTitle, description }: Props) => (
  <Helmet
    titleTemplate={`%s – ${pageTitle}`}
    defaultTitle={`${pageTitle} – Product, Fashion, Portrait Photographer`}
  >
    <meta name="description" content={description} />
    <meta name="author" content="Melissa O’Hearn" />
    <meta
      name="copyright"
      content={`© ${new Date().getFullYear()} Melissa O’Hearn`}
    />
    <link rel="icon" sizes="192x192" href={appleIcon192} />
    <link
      rel="apple-touch-icon-precomposed"
      sizes="180x180"
      href={appleIcon180}
    />
    <link
      rel="apple-touch-icon-precomposed"
      sizes="152x152"
      href={appleIcon152}
    />
    <link
      rel="apple-touch-icon-precomposed"
      sizes="144x144"
      href={appleIcon144}
    />
    <link
      rel="apple-touch-icon-precomposed"
      sizes="120x120"
      href={appleIcon120}
    />
    <link
      rel="apple-touch-icon-precomposed"
      sizes="114x114"
      href={appleIcon114}
    />
    <link rel="apple-touch-icon-precomposed" sizes="76x76" href={appleIcon76} />
    <link rel="apple-touch-icon-precomposed" sizes="72x72" href={appleIcon72} />
    <link rel="apple-touch-icon-precomposed" href={appleIcon} />
    <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
    <link rel="icon" type="image/png" sizes="96x96" href={favicon96} />
    <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
    <link rel="shortcut icon" href={favicon} type="image/x-icon" />
    <meta name="msapplication-TileColor" content="#ffffff" />
    <meta name="msapplication-TileImage" content={msIcon} />
    <meta name="theme-color" content="#ffffff" />
    <link rel="mask-icon" href={maskIcon} color="#FFC605" />
    <script type="application/ld+json">{`${JSON.stringify(
      structuredData,
      null,
      2,
    )}`}</script>
  </Helmet>
)

export default DefaultHead



// WEBPACK FOOTER //
// ./src/components/DefaultHead.js